import React, { lazy } from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtextedRoute";
import { routes } from "@/config/routes";
import { AccountType } from "@/types";

const ApiKeys = lazy(() => import("@/pages/Api/ApiKeys"));
const CreateApiKey = lazy(() => import("@/pages/Api/ApiKeys/Create"));
const ApiKeyDetails = lazy(() => import("@/pages/Api/ApiKeys/Details"));
const WalletCredentials = lazy(() => import("@/pages/Api/WalletCredentials"));
const CreateWalletCredential = lazy(() => import("@/pages/Api/WalletCredentials/Create"));
const WalletCredentialDetails = lazy(() => import("@/pages/Api/WalletCredentials/Details"));
const WalletTemplates = lazy(() => import("@/pages/Api/WalletTemplates"));
const CreateWalletTemplate = lazy(() => import("@/pages/Api/WalletTemplates/Create"));
const WalletTemplateDetails = lazy(() => import("@/pages/Api/WalletTemplates/Details"));
const WalletCards = lazy(() => import("@/pages/Api/WalletCards"));
const WalletCardDetails = lazy(() => import("@/pages/Api/WalletCards/Details"));
const PaymentMethods = lazy(() => import("@/pages/PaymentMethods"));
const Logs = lazy(() => import("@/pages/Api/Logs"));
const Documentation = lazy(() => import("@/pages/Api/Documentation"));
const ApiSettings = lazy(() => import("@/pages/Api/Settings"));

const ApiRoutes = (
    <React.Fragment>
        <Route
            path={routes.api.apiKeys.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><ApiKeys /></ProtectedRoute>}
        />
        <Route
            path={routes.api.apiKeys.create}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><CreateApiKey /></ProtectedRoute>}
        />
        <Route
            path={routes.api.apiKeys.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><ApiKeyDetails /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletCredentials.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><WalletCredentials /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletCredentials.create}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><CreateWalletCredential /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletCredentials.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><WalletCredentialDetails /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletTemplates.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><WalletTemplates /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletTemplates.create}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><CreateWalletTemplate /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletTemplates.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><WalletTemplateDetails /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletCards.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><WalletCards /></ProtectedRoute>}
        />
        <Route
            path={routes.api.walletCards.details}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><WalletCardDetails /></ProtectedRoute>}
        />
        <Route
            path={routes.api.paymentMethods.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><PaymentMethods /></ProtectedRoute>}
        />
        <Route
            path={routes.api.logs.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><Logs /></ProtectedRoute>}
        />
        <Route
            path={routes.api.documentation.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><Documentation /></ProtectedRoute>}
        />
        <Route
            path={routes.api.settings.root}
            element={<ProtectedRoute allowedAccountTypes={[AccountType.API_PARTNER]}><ApiSettings /></ProtectedRoute>}
        />
    </React.Fragment>
)

export default ApiRoutes;
